// extracted by mini-css-extract-plugin
module.exports = {"video":"video_video__EuXrX"};